import type { ReactElement } from "react";

import { cx, styled } from "simplydo/react/styled";

import { DimmerOverlay } from "./Modal.styles";
import type { ModalDimmerProps } from "./Modal.types";

/**
 * Standalone / shorthand dimmer surface. When used as `dimmer={<ModalDimmer />}`,
 * the root Modal clones it around the dialog.
 */

const ModalDimmerComponent = ({
  children,
  inverted,
  className,
  style,
  onClick,
}: ModalDimmerProps): ReactElement => {
  return (
    <DimmerOverlay
      className={cx(className)}
      style={style}
      $inverted={inverted}
      onClick={onClick}
      role="presentation"
    >
      {children}
    </DimmerOverlay>
  );
};

export const ModalDimmer = styled(ModalDimmerComponent)``;
